<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"500px"'
    :cpntOnFecharDialog='cfgContadorNovoCadastroFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      Cadastrar Novo Contador
    </template>

    <template slot='conteudo'>
      <div style="text-align: justify;">
        Prosseguindo com o cadastro, seu Contador irá receber um e-mail com instruções para acesso ao Rotina Fácil.
        <br/>
        <br/>
      </div>

      <div class="cfg-contador-novo-cadastro">
        <App-Input :data-time="time"
        :cpntStatus='campos.nome.status'
        :cpntId='campos.nome.id'
        :cpntTabIndex='campos.nome.tabIndex'
        :cpntNome='campos.nome.nome'
        :cpntValue='campos.nome.value'
        :cpntMensagem='campos.nome.mensagem'
        :cpntMensagemTipo='campos.nome.mensagemTipo'
        :cpntDisabled='campos.nome.disabled'
        :cpntMostrar='campos.nome.mostrar'
        :cpntExplica='campos.nome.explica'
        :cpntPlaceholder='campos.nome.placeholder'
        :cpntValueRef='campos.nome.valueRef'
        :cpntRouter='campos.nome.router'
        :cpntMethod='campos.nome.method'
        :cpntField='campos.nome.field'
        :cpntWhere='campos.nome.where'
        :cpntAddButForm='campos.nome.addButForm'
        :cpntKeyMostra='campos.nome.keyMostra'
        :cpntTipoOrder='campos.nome.tipoOrder'
        :cpntOrder='campos.nome.order'
        :cpntOptions='campos.nome.options'
        :cpntKeyValue='campos.nome.keyValue'
        :cpntSearchMinimo='campos.nome.searchMinimo'
        :cpntMask='campos.nome.mask'
        :cpntOnChange='campos.nome.onChange'
        :cpntOnBlur='campos.nome.onBlur'
        :cpntOnRealizaBusca='campos.nome.onRealizaBusca'
        :cpntOnKeyPressEnter='campos.nome.onKeyPressEnter'
        ref="nome"
        ></App-Input>

        <App-Input :data-time="time" v-if="$store.state.token.usuario !== 'SuporteRF'"
        :cpntStatus='campos.whatsapp.status'
        :cpntId='campos.whatsapp.id'
        :cpntTabIndex='campos.whatsapp.tabIndex'
        :cpntNome='campos.whatsapp.nome'
        :cpntValue='campos.whatsapp.value'
        :cpntMensagem='campos.whatsapp.mensagem'
        :cpntMensagemTipo='campos.whatsapp.mensagemTipo'
        :cpntDisabled='campos.whatsapp.disabled'
        :cpntMostrar='campos.whatsapp.mostrar'
        :cpntExplica='campos.whatsapp.explica'
        :cpntPlaceholder='campos.whatsapp.placeholder'
        :cpntValueRef='campos.whatsapp.valueRef'
        :cpntRouter='campos.whatsapp.router'
        :cpntMethod='campos.whatsapp.method'
        :cpntField='campos.whatsapp.field'
        :cpntWhere='campos.whatsapp.where'
        :cpntAddButForm='campos.whatsapp.addButForm'
        :cpntKeyMostra='campos.whatsapp.keyMostra'
        :cpntTipoOrder='campos.whatsapp.tipoOrder'
        :cpntOrder='campos.whatsapp.order'
        :cpntOptions='campos.whatsapp.options'
        :cpntKeyValue='campos.whatsapp.keyValue'
        :cpntSearchMinimo='campos.whatsapp.searchMinimo'
        :cpntMask='campos.whatsapp.mask'
        :cpntOnChange='campos.whatsapp.onChange'
        :cpntOnBlur='campos.whatsapp.onBlur'
        :cpntOnRealizaBusca='campos.whatsapp.onRealizaBusca'
        :cpntOnKeyPressEnter='campos.whatsapp.onKeyPressEnter'
        ref="whatsapp"
        ></App-Input>

        <App-Input :data-time="time"
        :cpntStatus='campos.email.status'
        :cpntId='campos.email.id'
        :cpntTabIndex='campos.email.tabIndex'
        :cpntNome='campos.email.nome'
        :cpntValue='campos.email.value'
        :cpntMensagem='campos.email.mensagem'
        :cpntMensagemTipo='campos.email.mensagemTipo'
        :cpntDisabled='campos.email.disabled'
        :cpntMostrar='campos.email.mostrar'
        :cpntExplica='campos.email.explica'
        :cpntPlaceholder='campos.email.placeholder'
        :cpntValueRef='campos.email.valueRef'
        :cpntRouter='campos.email.router'
        :cpntMethod='campos.email.method'
        :cpntField='campos.email.field'
        :cpntWhere='campos.email.where'
        :cpntAddButForm='campos.email.addButForm'
        :cpntKeyMostra='campos.email.keyMostra'
        :cpntTipoOrder='campos.email.tipoOrder'
        :cpntOrder='campos.email.order'
        :cpntOptions='campos.email.options'
        :cpntKeyValue='campos.email.keyValue'
        :cpntSearchMinimo='campos.email.searchMinimo'
        :cpntMask='campos.email.mask'
        :cpntOnChange='campos.email.onChange'
        :cpntOnBlur='campos.email.onBlur'
        :cpntOnRealizaBusca='campos.email.onRealizaBusca'
        :cpntOnKeyPressEnter='campos.email.onKeyPressEnter'
        ref="email"
        ></App-Input>       

        <br/>

        <RF-Button
          :cpntId='botoes.salvar.id'
          :cpntStatus='botoes.salvar.status' 
          :cpntTexto='botoes.salvar.texto'
          :cpntTipo='botoes.salvar.tipo'
          :cpntIcone='botoes.salvar.icone'
          :cpntClass='botoes.salvar.class'
          @onClickButton='() => { botoes.salvar.onClick() }'>
          </RF-Button>
      </div>

      <div v-if="bloqueado === true" class="cfg-contador-novo-cadastro-bloqueado"></div>

    </template>
  </RF-Dialog>
</template>

<style scoped>
.cfg-contador-novo-cadastro {
  margin-top: 15px;
  text-align: center;
}
  .cfg-contador-novo-cadastro > div {
    width: 300px;
  }
  .cfg-contador-novo-cadastro > button,
  .cfg-contador-novo-cadastro > div:not(:first-child) {
    margin-top: 20px;
  }
  .cfg-contador-novo-cadastro > button {
    width: 150px;
  }

  .cfg-contador-novo-cadastro-bloqueado {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 100000000;
    cursor: no-drop;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        bloqueado: false,
        campos: {
          nome: {
            id: 'cfg-contador-novo-cadastro--nome',
            status: '',
            nome: 'Nome',
            value: '',
            onChange: this.cfgContadorNovoCadastroOnChangeValue
          },
          whatsapp: {
            id: 'cfg-contador-novo-cadastro--whatsapp',
            status: '',
            nome: 'WhatsApp',
            mask: 'telefone',
            value: '',
            onChange: this.cfgContadorNovoCadastroOnChangeValue
          },
          email: {
            id: 'cfg-contador-novo-cadastro--email',
            status: '',
            nome: 'E-mail',
            value: '',
            onChange: this.cfgContadorNovoCadastroOnChangeValue
          },
        },
        botoes: {
          salvar: {
            status: '',
            id: 'cfg-contador-novo-cadastro--salvar',
            texto: 'Cadastrar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.cfgContadorNovoCadastroSalvar() }
          },
        }
      }
    },
    mounted: function () {
      this.cfgContadorNovoCadastroIniciar()
    },
    methods: {
      cfgContadorNovoCadastroIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.cfgContadorNovoCadastroSetaStatusGeral('')

        // REALIZA O FOCUS NO PRIMEIRO CAMPO
        this.cfgContadorNovoCadastroRealizarFocusCampo('nome')
      },
      cfgContadorNovoCadastroSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cfgContadorNovoCadastroFechar: function (atualizar = false) {
        this.cpntFecharFormulario(atualizar)
      },
      cfgContadorNovoCadastroOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cfgContadorNovoCadastroSalvar: function () {
        if ([ '', null, undefined ].indexOf(this.campos.nome.value) !== -1) {
          // APRESENTA A MENSAGEM
          this.$store.state.msgWarn('WEB [400]: É necessário preencher um nome válido do contador.', 'danger')

          // REALIZA O FOCUS NO CAMPO
          this.cfgContadorNovoCadastroRealizarFocusCampo('nome')
        } else if ([ '', null, undefined ].indexOf(this.campos.whatsapp.value) !== -1 && [ '', null, undefined ].indexOf(this.campos.email.value) !== -1) {
          // APRESENTA A MENSAGEM
          this.$store.state.msgWarn('WEB [400]: É necessário preencher um WhatsApp ou e-mail válido do contador.', 'danger')

          // REALIZA O FOCUS NO CAMPO
          this.cfgContadorNovoCadastroRealizarFocusCampo('email')
        } else if (this.$store.state.token.usuario !== 'SuporteRF') {
          this.cfgContadorNovoCadastroEnviarEmail()
        } else {
          // BLOQUEA TOTALMENTE A TELA
          this.bloqueado = true
          
          // SETA O STATUS DO BOTÃOP
          this.botoes.salvar.status = 'carregando'
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
  
          // SETA A FUNÇÃO PARA EXECUTAR
          var finalizar = () => {
            // BLOQUEA TOTALMENTE A TELA
            this.bloqueado = false
            
            // SETA O STATUS DO BOTÃOP
            this.botoes.salvar.status = ''
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
  
          // MONSTA O QUERY GET
          var queryGet = window.btoa(this.campos.email.value)
  
          // REALIZA A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/subase/cadastro/chk-mail/get/', 'GET', queryGet, (retorno) => {
            if ([ '', null, undefined ].indexOf(retorno.data['tok-pre-cadastro']) === -1) {
              // INICIA O FORMULARIO DA API
              var formData = {
                intencao: 'contador',
                nome: this.campos.nome.value,
                'tok-pre-cadastro': retorno.data['tok-pre-cadastro'],
                'act-demonstrativo': 'true',
                'clu-indica': this.$store.state.token.clu.toString(),
                clu: retorno.data.clu
              }
  
              // REALIZA A COMUNICAÇÃO COM A API
              this.$store.state.comunicaAPI('/subase/cadastro/cli-novo', 'POST', formData, (retorno) => {
                this.cfgContadorNovoCadastroLogar(retorno.data.conta, finalizar)
              }, (apiError) => {
                // SETA O STATUS DA PAGINA
                this.cfgContadorNovoCadastroSetaStatusGeral(apiError)
  
                // EXECUTA A FUNÇÃO SOLICITADA
                finalizar()
              })
            } else if ([ '', null, undefined ].indexOf(retorno.data.conta) === -1) {
              this.cfgContadorNovoCadastroFinalizar(retorno.data.conta, finalizar)
            }
          }, (apiError) => {
            // SETA O STATUS DA PAGINA
            this.cfgContadorNovoCadastroSetaStatusGeral(apiError)
  
            // EXECUTA A FUNÇÃO SOLICITADA
            finalizar()
          })
        }
      },
      cfgContadorNovoCadastroLogar: function (conta, finalizar) {
        // SETA OS DADOS DE LOGIN
        var formData = { conta: conta, senha: 'subase' }

        // SETA A INFORMAÇÃO SE ESTA RODANDO NO ELECTRON OU NÃO
        formData.ect = window.ELECTRON

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/acesso', 'POST', formData, (retorno) => {
          // // IMPORTA A FUNÇÃO
          // const SESSAO_TRATAR_DADOS_TOKEN = require('@/assets/js/Sessao.js').SESSAO_TRATAR_DADOS_TOKEN
          
          // // CARREGA OS DADOS DO TOKEN
          // SESSAO_TRATAR_DADOS_TOKEN({ conta: conta, token: retorno.data.token })

          // CONVERTE O VALOR DOS PACOTES EM UM JSON
          var formData = { j_pacotes: JSON.stringify([ 1, 34 ]) }
          
          // SETA OS PACOTES DA LICENÇA DE USO
          this.$store.state.comunicaAPI('/config/pacote', 'PUT', formData, () => {
            this.cfgContadorNovoCadastroFinalizar(conta, finalizar)
          }, (apiError) => {
            // SETA O STATUS DA PAGINA
            this.cfgContadorNovoCadastroSetaStatusGeral(apiError)

            // EXECUTA A FUNÇÃO SOLICITADA
            finalizar()
          }, null, retorno.data.token)
        }, (apiError) => {
          // SETA O STATUS DA PAGINA
          this.cfgContadorNovoCadastroSetaStatusGeral(apiError)

          // EXECUTA A FUNÇÃO SOLICITADA
          finalizar()
        })
      },
      cfgContadorNovoCadastroFinalizar: function (conta, finalizar) {
        // PEGA O NOME DA CLU A SER SALVA
        var clu = conta.split('@')[1]

        // FINALIZA A DIALOG
        finalizar()

        // FECHA A JANELA ABERTA
        this.cpntFecharFormulario(true, clu)
      },
      cfgContadorNovoCadastroRealizarFocusCampo: function (chave, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
            this.$refs[chave].cpntRealizarFocus()
          } else {
            setTimeout(() => { this.cfgContadorNovoCadastroRealizarFocusCampo(chave, (tentativa + 1)) }, 100)
          }
        }
      },
      cfgContadorNovoCadastroEnviarEmail: function () {
        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = {}

        // SETA O ASSUNTO DO E-MAIL
        formData.assunto = this.$store.state.dadosApi.datetime + ' - RF - Solicitação de cadastro de um novo contador'

        // SETA O CONTEUDO DO E-MAIL
        formData.corpo = '<div style="font-family: calibri; font-size: 14px; width: 500px; padding: 10px; border: 1px solid #ccc; border-radius: 5px;"><img src="' + this.$store.state.logotipo + '" style="width: 150px;"/><div style="margin-top: 10px; font-family: calibri; font-size: calc(100% - 2px);">Este é um e-mail foi enviado através do sistema Rotina Fácil.</div><div style="margin-top: 10px;">Prezado(s),</div><div style="margin-top: 10px;">O cliente descrito abaixo: </div><div style="margin-top: 10px; padding: 10px; border-radius: 5px; background: #e9e9e9; border: 1px solid #ccc;"><table style="width: 100%;"><tr><td style="vertical-align: top;"><div style="display: inline-block; width: 10%; max-width: 10%; min-width: 10%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">CLU:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.clu + '</div></div><div style="display: inline-block; width: 90%; max-width: 90%; min-width: 90%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Razão Social:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.rSocial + '</div></div></td></tr><tr><td style="vertical-align: top;"><div style="display: inline-block; width: calc(100% / 3); max-width: calc(100% / 3); min-width: calc(100% / 3);"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">CNPJ:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.cnpj + '</div></div><div style="display: inline-block; width: calc(100% / 3); max-width: calc(100% / 3); min-width: calc(100% / 3);"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Inscrição Estadual:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.ie + '</div></div><div style="display: inline-block; width: calc(100% / 3); max-width: calc(100% / 3); min-width: calc(100% / 3);"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Inscrição Municipal:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.im + '</div></div></td></tr><tr><td style="vertical-align: top;"><div style="display: inline-block; width: calc(100% / 3); max-width: calc(100% / 3); min-width: calc(100% / 3);"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Telefone:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.telefone + '</div></div><div style="display: inline-block; width: calc(100% / 1.5); max-width: calc(100% / 1.5); min-width: calc(100% / 1.5);"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">E-mail:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.email.split(";").join("<br/>") + '</div></div></td></tr><tr><td style="vertical-align: top;"><div style="width: 100%; max-width: 100%; min-width: 100%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">CEP:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.cep + '</div></div></td></tr><tr><td style="vertical-align: top;"><div style="width: 100%; max-width: 100%; min-width: 100%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Endereço:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.endereco + ', ' + this.$store.state.licenca.numero + ' (' + this.$store.state.licenca.complemento + ')</div></div></td></tr><tr><td style="vertical-align: top;"><div style="display: inline-block; width: 40%; max-width: 40%; min-width: 40%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Bairro:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.bairro + '</div></div><div style="display: inline-block; width: 40%; max-width: 40%; min-width: 40%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Cidade:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.cidade + '</div></div><div style="display: inline-block; width: 20%; max-width: 20%; min-width: 20%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">UF:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.$store.state.licenca.uf + '</div></div></td></tr></table></div><div style="margin-top: 10px;">Está solicitiando que sua licença de uso seja vinculado ao contador abaixo: </div><div style="margin-top: 10px; padding: 10px; border-radius: 5px; background: #e9e9e9; border: 1px solid #ccc;"><table style="width: 100%"><tr><td style="vertical-align: top;"><div style="display: inline-block; width: 70%; max-width: 70%; min-width: 70%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Nome:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.campos.nome.value + '</div></div><div style="display: inline-block; width: 30%; max-width: 30%; min-width: 30%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">Telefone:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;"><a href="https://web.whatsapp.com/send?phone=55' + this.campos.whatsapp.value.replace(/[^0-9]/g,'') + '">' + this.campos.whatsapp.value + '</a></div></div></td></tr><tr><td style="vertical-align: top;"><div style="display: inline-block; width: 100%; max-width: 100%; min-width: 100%;"><div style="font-family: calibri; font-size: 11px; line-height: 13px; padding-top: 5px; color: #0648cd; display: inline-block;">E-mail:</div><div style="color: #444; font-family: calibri; font-size: 14px; line-height: 16px; margin-top: 2px;">' + this.campos.email.value + '</div></div></td></tr></table></div><div style="margin-top: 10px;"><b>Verificar atentamente se o contador já não está cadastrado, para evitar duplicidade de banco de dados.</b></div><div style="margin-top: 10px;">Att,</div><div style="margin-top: 0px;">Equipe Software Rotina Fácil</div></div>'

        // BLOQUEA TOTALMENTE A TELA
        this.bloqueado = true
        
        // SETA O STATUS DO BOTÃOP
        this.botoes.salvar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO PARA EXECUTAR
        var finalizar = () => {
          // BLOQUEA TOTALMENTE A TELA
          this.bloqueado = false
          
          // SETA O STATUS DO BOTÃOP
          this.botoes.salvar.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // REALIZA A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/subase/env-email', 'POST', formData, () => {
          // APRESENTA A MENSAGEM AO CLIENTE
          this.$store.state.msgWarn('WEB [200]: Solicitação enviada com sucesso. Por favor, aguarde a vinculação ser realizada pela equipe Rotina Fácil.', 'success')

          // EXECUTA A FUNÇÃO SOLICITADA
          finalizar()
        }, (apiError) => {
          // SETA O STATUS DA PAGINA
          this.cfgContadorNovoCadastroSetaStatusGeral(apiError)

          // EXECUTA A FUNÇÃO SOLICITADA
          finalizar()
        }, (apiValid, apiStatus) => {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(finalizar)
        } )
      }
    }
  }
</script>
